// extracted by mini-css-extract-plugin
export var audioPlayer = "_qq-0";